import {
  AuthOperationsApi,
  Configuration,
  ConfigurationParameters} from '../../../components/api';

const configParams: ConfigurationParameters = {
  basePath: process.env.PUBLIC_URL
};

const apiConfig = new Configuration(configParams);

export const apiClient = {
  authApi: new AuthOperationsApi(apiConfig)
};

export type ApiClient = typeof apiClient;
